<template>
  <el-dialog width="520px"
             v-dialog-drag
             title="设置小程序用户隐私"
             :before-close="handleClickCancel"
             :close-on-press-escape="false"
             :close-on-click-modal="false"
             :visible.sync="setPrivacySettingVisible">
    <div class="from_box">
      <el-radio-group v-model="currencyForm.privacy_ver">
        <el-radio label="1">现网版本</el-radio>
        <el-radio label="2">开发版本</el-radio>
      </el-radio-group>
    </div>
    <div slot="footer">
      <el-button size="small"   :disabled="btnDisabled" @click="handleClickCancel">取消</el-button>
      <el-button size="small"   :disabled="btnDisabled" @click="handleClickConfirm" type="primary">确定</el-button>
    </div>
  </el-dialog>
</template>
<script>
import {setPrivacySetting} from "@/api";

export default {
  name: "set_privacySetting",
  props: {
    setPrivacySettingVisible: {
      type: Boolean,
      default: false,
    },
    weChatAppId: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      loading: false,
      btnDisabled: false,
      currencyForm:{
        privacy_ver:'1', //1表示现网版本；2表示开发版
      },
      currencyFormRules:{

      },
    }
  },
  created() {


  },
  mounted() {
  },
  methods: {

    handleClickCancel() {
      this.$emit('update:setPrivacySettingVisible', false)
    },

    handleClickConfirm() {
      this.btnDisabled = true
      setPrivacySetting({privacy_ver: this.currencyForm.privacy_ver},{
        headers:{
          appid: this.weChatAppId,
        }
      }).then(res => {
        if (res.data.errcode === 0) {
          this.$message({
            message: res.data.errmsg,
            type: 'success',
            duration: 2000,
            onClose: () => {
              this.$emit('update:setPrivacySettingVisible', false)
            }
          })
        }
        this.loading = false
      })

    },
  }
}
</script>
<style lang="scss" scoped>
.from_box{
  padding: 30px 0 15px;
}
</style>
